import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as recipeReducer from "containers/Recipe/reducer";

import TraySolutionItem from "containers/View/Item/TraySolutionItem";

import SubView from "components/View/SubView";

class TraySolutionViewContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.fetchAll();
  }

  renderTile(index, style) {
    const { solutionIds, recipeId, onClick } = this.props;

    if (index >= solutionIds.length) {
      return undefined;
    }

    const id = solutionIds[index];

    return <TraySolutionItem id={id} recipeId={recipeId} onClick={onClick} key={index} style={style} />;
  }

  render() {
    const { solutionIds, isLoading, fetchNext, fetchAll } = this.props;

    return (
      <SubView
        type="solution"
        isTile={true}
        isLoading={isLoading}
        fetchNext={fetchNext}
        fetchAll={fetchAll}
        label="Tray Solutions"
        length={solutionIds.length}
        isInfinite={true}
        renderTile={this.renderTile.bind(this)}
        childrenLength={solutionIds.length}
        height={"35vh"}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(recipeReducer.fetchSolutions()),
  fetchAll: () => dispatch(recipeReducer.fetchSolutions())
});

const mapStateToProps = (state, ownProps) => ({
  solutionIds: recipeReducer.getSolutionIds(state),
  isLoading: ownProps.isLoading || recipeReducer.getSolutionListIsLoading(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TraySolutionViewContainer);
